import {
  StyledNutrientInformation,
  StyledLabel,
  StyledInfoBox,
  NutrientDetailsBox,
  NutrientDetailsItemLabel,
  NutrientDetailsItemValue,
  NutrientDetailsItemPercent,
  StyledNutrientInfoHeader,
  EditNutrientLabel,
} from "./styled"
import { formatDisplayNumber, getDisplayMealMacro } from "utils"
import { FlexBox } from "components/Common/FlexBox"
import { getCaloriesPercentFromMacrosGram } from "features/profile/hooks/manualEditGoal/helper"
import { INutrition } from "model/food/types/base.types"
import NutrientPieChart from "../NutrientInformation/NutrientPieChart"

interface INutrientDetailsItem {
  name: string
  color: string
  value: number
  percent: string
  gram: number
}

const NutrientDetailsItem = (props: INutrientDetailsItem) => {
  const { name, color, percent, gram } = props
  return (
    <FlexBox $direction="column" $gap={4} style={{ width: 65, flexShrink: 0 }}>
      <NutrientDetailsItemLabel>{name}</NutrientDetailsItemLabel>
      <div>
        <NutrientDetailsItemValue>
          {getDisplayMealMacro(gram)} g
        </NutrientDetailsItemValue>

        <NutrientDetailsItemPercent $color={color}>
          {percent}
        </NutrientDetailsItemPercent>
      </div>
    </FlexBox>
  )
}

interface IProps<T extends INutrition> {
  entry: T
  setEditMode: () => void
}

const EditableNutrientInformation = <T extends INutrition>({
  entry,
  setEditMode,
}: IProps<T>) => {
  const { protein, carbohydrate, fat, calorie } = entry

  const { proteinPercent, fatPercent, carbPercent } =
    getCaloriesPercentFromMacrosGram({
      proteinGram: protein,
      fatGram: fat,
      carbsGram: carbohydrate,
    })

  const nutrient: INutrientDetailsItem[] = [
    {
      name: "Protein",
      color: "#F354E4",
      value: proteinPercent,
      gram: protein,
      percent: formatDisplayNumber(proteinPercent) + "%",
    },

    {
      name: "Fat",
      color: "#F7BA1E",
      value: fatPercent,
      gram: fat,
      percent: formatDisplayNumber(fatPercent) + "%",
    },
    {
      name: "Carbs",
      color: "#722ED1",
      value: carbPercent,
      gram: carbohydrate,
      percent: formatDisplayNumber(carbPercent) + "%",
    },
  ]

  return (
    <StyledNutrientInformation>
      <StyledInfoBox>
        <StyledNutrientInfoHeader>
          <StyledLabel>Nutritional Information</StyledLabel>
          <EditNutrientLabel onClick={setEditMode}>Edit</EditNutrientLabel>
        </StyledNutrientInfoHeader>

        <FlexBox $gap={24} style={{ padding: "12px 12px 16px 12px" }}>
          <NutrientPieChart nutrient={nutrient} calorie={calorie} />

          <NutrientDetailsBox>
            {nutrient.map((data, index) => (
              <NutrientDetailsItem key={index} {...data} />
            ))}
          </NutrientDetailsBox>
        </FlexBox>
      </StyledInfoBox>
    </StyledNutrientInformation>
  )
}

export default EditableNutrientInformation
